import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

// Shared with preloadInitialRoute, so a cold load fetches the page chunk in parallel with the boot gates.
export const importMonitoringPage = () => import('@cobliteam/monitoring/src/pages/MonitoringPage');
export const importMonitoringPageV2 = () => import('@cobliteam/monitoring/src/pages/MonitoringPageV2/MonitoringPageV2');

const MonitoringPage = lazy(importMonitoringPage);
const MonitoringPageV2 = lazy(importMonitoringPageV2);

const routes = [
  {
    title: locationName[Location.MONITORING],
    path: Location.MONITORING,
    component: MonitoringPage,
    needsGoogleMaps: true,
  },
  {
    title: locationName[Location.MONITORING_V2],
    path: Location.MONITORING_V2,
    component: MonitoringPageV2,
    featureFlag: 'monitoringV2',
    needsGoogleMaps: true,
  },
];

export default routes;
